// Components/ui
import { useTranslationContext } from '../../../../../../../context/TranslationContext';
import { Warning } from './components';
import { Box, Grid } from '@mui/material';

type WarningsDisplayProps = {
  warnings: string[];
};

const WarningsDisplay = ({ warnings }: WarningsDisplayProps) => {
  const t = useTranslationContext();

  return (
    <Box>
      <Grid container>
        {warnings?.map((warning, i) => (
          <Warning key={i} text={t(`contactAddressError.${warning}`)} />
        ))}
      </Grid>
    </Box>
  );
};

export default WarningsDisplay;
